import { ISetSelfServiceSubscriptionsFrequencyParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSelfServiceSubscriptionsFrequencyRequest extends Request<ISetSelfServiceSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSelfServiceSubscriptionsFrequencyParams) {
        super('setSubscriptionsSelfServiceSchedule', params);
    }
}
